module.exports = __webpack_public_path__ + "static/media/attachCard.8636f163.svg";